/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable no-nested-ternary */
/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/react-in-jsx-scope */

import React, { useEffect, useState, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Col, Container, Image, Row, Spinner, Tab, Tabs } from "react-bootstrap";
import axios from "axios";
import DOMPurify from "dompurify";
import swal from "sweetalert";
// eslint-disable-next-line import/no-extraneous-dependencies
import Swal from "sweetalert2";

import "./paymentPublic.scss";
import Barcode from "react-barcode";
import Countdown from 'react-countdown';
import AlertDialog from "../dialog/alert";
import Formatter from "../../helper/formatter";
import DateTime from "../../helper/datetime";
import LinkquLogo from "../../assets/imgs/icons/linkqu.png";
import QrisLogo from "../../assets/imgs/icons/qris.png"
import alfaLogo from "../../assets/imgs/logo/alfamart.png"
import indoLogo from "../../assets/imgs/logo/indomaret.png"
import creditLogo from "../../assets/imgs/icons/creditcard.png"
import icons from "../../helper/icons";
import iconName from "../../helper/constant/iconName";
import BANNER from '../../assets/imgs/line_shape.png';
import paymentInstructions from "./paymentInstructions";

const PaymentRequestPublic = () => {
  const { idPayment } = useParams();

  const [initial, changeInitial] = useState({
    loading: false,
    alertError: "",
    data: null,
    dataBank: [],
    pageTitle: "Invoice Payment Link",
    successGeneratedVAData: null,
    email_user: '',
    totalAmount: '',
    type_user: '',
  });


  const [mainContent, changeMainContent] = useState({
    detailContent: true,
    paymentContent: false,
    createdVa: false,
  });

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });

  const [emailUser, setEmailUser] = useState('')
  const [nameUser, setNameUser] = useState('')
  const [notelpUser, setNumberPhoneUser] = useState('')

  const bankListContent = () => {
    changeMainContent({
      detailContent: true,
      createdVa: false,
    });
  };

  const createdVAContent = (email) => {
    changeMainContent({
      detailContent: false,
      createdVa: true,
    });
  };

  const generateVAPersonal = async (bankCode, email) => {
    changeInitial({ ...initial });
    const url = `${process.env.REACT_APP_API_URL}api/publics/generated_va`;

    try {
      const response = await axios
        .get(url, {
          params: { id_payment: initial.data.id, code_bank: bankCode, email_user: email, brand: process.env.REACT_APP_BRAND_NAME.toLowerCase() },
        })
        .then((res) => res)

      if (response.data.rc == "00") {
        changeInitial({
          ...initial,
          successGeneratedVAData: response.data.data.data,
          totalAmount: response.data.data.data.amount
        });
        createdVAContent();
      } else {
        changeInitial({
          ...initial,
          alertError: response.data.rd,
        });
      }
    } catch (error) {
      console.log(error);
      changeInitial({ ...initial, alertError: error.rd });
      bankListContent();
    }
  };

  const generateVABisnis = async (bankCode, email, name, notelp) => {
    changeInitial({ ...initial });
    const url = `${process.env.REACT_APP_API_URL}api/publics/generated_va`;

    try {
      const response = await axios
        .post(url, {
          params: { id_payment: initial.data.id, code_bank: bankCode, email: email, name: name, notelp: notelp },
        })
        .then((res) => res)

      if (response.data.rc == "00") {
        changeInitial({
          ...initial,
          successGeneratedVAData: response.data.data.data,
          totalAmount: response.data.data.data.amount
        });
        createdVAContent();
      } else {
        changeInitial({
          ...initial,
          alertError: response.data.rd,
        });
      }
    } catch (error) {
      console.log(error);
      changeInitial({ ...initial, alertError: error.rd });
      bankListContent();
    }
  };

  const addBodyClass = (className) => document.body.classList.add(className);
  const removeBodyClass = (className) =>
    document.body.classList.remove(className);

  const getData = async () => {
    changeInitial({ ...initial, loading: true });
    let url = `${process.env.REACT_APP_API_URL}api/publics/request_payment_detail`;

    try {
      let response = await axios
        .get(url, { params: { paymentSecret: idPayment } })
        .then((res) => res.data)

      if (response.rc == "00") {
        const responseData = response.data.data["payment-request"]
        const typeUser = response.data.data["type-user"]
        url = `${process.env.REACT_APP_API_URL}api/publics/list_va`
        response = await axios.get(url).then((res) => res.data);
        
        if (response.rc == "00") {
          const bankExist = [];
          const bankNotUsed = [];

          for (let i = 0; i < response.data.data.length; i++) {
            if (response.data.data[i].kodeBank == 523 || response.data.data[i].kodeBank == 'QRISB' || response.data.data[i].kodeBank == 'PAYGOPAY' || response.data.data[i].kodeBank == 'PAYOVO') {
              bankNotUsed.push(response.data.data[i])
            } else {
              bankExist.push(response.data.data[i])
            }
          }

          changeInitial({
            ...initial,
            data: responseData,
            dataBank: bankExist,
            type_user: typeUser,
            loading: false
          });
          bankListContent();
          // response = {data : {
          //   rc: "00",
          //   rd: "Success",
          //   data: {
          //     rc: "00",
          //     rd: "Virtual Account Successfully Created",
          //     total: 0,
          //     balance: 0,
          //     data: {
          //       // imageQris: "iVBORw0KGgoAAAANSUhEUgAAAfQAAAH0AQAAAADjreInAAAFh0lEQVR42u2dTY7bSgyEKcxilj6CjuKjSUfzUXQEL70wzKhZxZYsZ5AAD3higPIihm19nQWb3fwf8//0upt48eLFixcvXvy/yN+tvb7db/b6elyWq8ebmT/X769uX34fb5N7+20envH4IL4MP67/PL/vdp3XR9fX/Io3j2duU/uERW30lf/uv4mvwd+sfUvBBx+iXuV/WTdFCL5J/NE+De1/skl8Nb6p8Srq0OZYpimuL/Fo6C9B8TX5dv5Cxnw0XmPI3+L8bdpsLr4c/3b+rorbtkE7atsT6/1p8Vsu86fzW/z/zcP+aTralPOPbz/YT+JP4vO1HrW0cbgbIP8ZKj7xbv3ZfxF/Dt/k36Q6Nv+D+huP4vxtEoc3EvI32kbiy/AdDIsn7891GWtGbdsG2Bvhm3hYuuLr8OF4mDWJ0wx6Ncn3G/NFMwgH7963FF+BbzZO+BirxsLx4G4YtmN45dffaNO2EI/4SjwFPzFi0zx+j9UQf4tFsRvaSX3JJ8VX4NvhikfzxMWlClMV56/D/ml3a+q2+CJ8BG5g6tANsTBjHUHxCU6lMxr+m/iN+JP5azoUMFUnKvX+xrzFwRuKizC4+Er8y0KqeMYo/6bNzm3gGemxUPF3/1H8qfzoc7qRfTe01Xr+kPHTQ2xAfA0+Lsc8asPiQRjHaRS1/G982XMbi/hK/MLE05Vh8L4pngx8h4nkyB/6zigSX4O/QtTe7Fe6inAjkUbEocy1aRS5+Ep86KgxOOrMH8LV8CG3CF0Uu3zG38SfzFtXVVTMYDX3Lv/wJkfU1rzHb8Sfy9+NgW9YrD1VYVE/Q9sIIdaFTsl1Fl+K96y/2EI1yFgsEcbJZRAi6E+Kr8HHoyFxHLWRqveoXwtVjdWM+d++mvgaPM5fpHr9cI3CN7Gt8NB+Or/Fn8XjW9SIsjgGb5S/daPWxn4au/gqPG0clBpSjdPxsLxGkQZuJW59p4ivwfdSp1TcmaEaJIURRm3yd1ZjMGAnvgbvKLxA/SgbX1A4w2vUIyiXt2l86YP4UjzLuB39S5HNoPzniKaytttT/uLL8Ew82dF+xfnb/f8MCsSX4uvwvlU8hY/x7j9ePcvYvngaG7eB+CI8ujovC52LrDFMxUVsLpXaum6Lr8HjOozkUsTY4I2kj5/9g6x/ijKag/6LP5WP+jW83vJPqD80Nr5YNjU9e1JDfA0exaEX7/YPewR7UPVhG0+Fd/Fl+KV59Si1QI5iSKckRP1ibgrxN3ZqD+Kr8CFqNO5mGh+p3mx1YeMSCu9fH/Uz4s/ls+Ml2njtsvWfDYyfwprNTid4KuLL8Gn/ZFVo9p/tRb1Yxr9RVDqLL8Mz/xQyZhsoIqb4lEXBSGpMvz2/xZ/Ix/yD3saE5NIjS2X2sbldpGAWX4Zn/2eE2rZRW2zVjTEy7D/jpJKP/JX4c3kMTjOaQVv+yVL+YRsxqT989l+LP5mHqbM1zmfFPVpdcuJBFtUc58eIP5dHOyBkzKsyW5WyjZ73Z1vGPs9v8afybBy0MRMX2X+WE396iwyHWtzH9/p78afyLDyMH/P+ZFHiw3I2Amtr0CJ66L8XfyqfzbmZnLhNPX6DT8g/scWCaiy+DM/z13JGmnufX/i9n+b0lSGCQ/2M+NN5y+B2HxXT5295xt8yN2UIA4ivwvdhdmavff/ZNPTaxOw/24ZSii/D96qK3cRlz1G9WTFzmN9r4uvwOHG9D65PVR02o+gtGn6s3xd/Mt+nmjONmG4I+3c5f5Ij1j7r78WX4OkV7vvPOH+STmX3NA/nr/gSPGaM5Bi8BdPUelBn8mxq+sw/iT+X380/R8UoHX88uu8/i2Uu4kvxm/2TfyrCe6vuwjbCPs2J09TEl+H197/EixcvXrx48eL/mv8FrvfaW1zD9zAAAAAASUVORK5CYII=",
          //       vaNumber: "8848000009581450",
          //       amount: 24000,
          //       feeadmin: 4000,
          //       namaBank: "BANK BNI",
          //       customerReff: "LINKQUPAYREQ.14698.1746977786085",
          //       kodBank: "CREDITCARD",
          //       id: 18168,
          //       paymentName: "tesssss",
          //       expiredTime: "20250512235959",
          //       customerName: "yadi",
          //       email: "linkqutes10@gmail.com",
          //       phoneNo: "085233496314"
          //     },
          //     request: {},
          //     lastUpdate: "",
          //     dataadditional: {}
          //   }
          // }};

          // changeInitial({
          //   ...initial,
          //   data: responseData,
          //   dataBank: bankExist,
          //   type_user: typeUser,
          //   loading: false,
          //   successGeneratedVAData: response?.data?.data?.data,
          //   totalAmount: response?.data?.data?.data?.amount
          // });
          // createdVAContent();
          
        } else {
          changeInitial({ ...initial, loading: false, alertError: response.rd, dataBank: [] });
        }
      } else {
        changeInitial({ ...initial, loading: false, alertError: response.rd, data: null });
      }
    } catch (error) {
      console.log(error);
      changeInitial({ ...initial, loading: false, alertError: error.rd, data: null });
    }
  };

  const [selectedBank, selectedBankState] = useState({
    bank: null,
  });

  const [activeCategory, setActiveCategory] = useState('virtual');

  const [disableButtonPay, disableButtonPayState] = useState({
    disabled: true,
  });

  const closeError = () => {
    changeInitial({ ...initial, alertError: "" });
  };

  useEffect(() => {
    addBodyClass("page--requestPaymentPublic");
    getData(); 
    return () => {
      removeBodyClass("page--requestPaymentPublic");
    };
  }, []);

  const isExpired = (dateExp) => {
    return dateExp < DateTime.today(DateTime.FMT_DATE_TIME_YMDHMS)
  }

  const inputEmailUser = async () => {
    swal({
      title: "Input your Email",
      icon: icons(iconName.warningDialog),
      content: "input",
      buttons: {
        cancel: {
          text: 'Cancel',
          value: 'cancel',
          visible: true,
          closeModal: true,
        },
        confirm: {
          text: 'PAY',
          closeModal: true,
          className: 'swal-red-btn'
        }
      }
    }).then((email) => {

      if (email === '') {
        swal("Alert", "Input Your Email First!", "error").then(() => swal.close())
      } else if (email === 'cancel') {
        swal.close()
      } else {
        setEmailUser(email)
        swal.close();
        generateVAPersonal(selectedBank.bank.kodeBank, email);
      }
    })
  }

  const inputDataUser = async () => {
    // const { value: formValues } = await Swal.fire({
    await Swal.fire({
      title: "Input Your Data",
      animation: false,
      html:
        '<label for="name" class="fontSize-16-Medium form-label">Name</label><br>' +
        '<input id="swal-input-name" class="custom-input fontSize-16 " placeholder="Input Your Name"><br>' +
        '<label for="email" class="fontSize-16-Medium form-label mt-3">Email</label><br>' +
        '<input id="swal-input-email" class="custom-input fontSize-16 " placeholder="Input Your Email Address"><br>'+
        '<label for="number_phone" class="fontSize-16-Medium form-label mt-3">Number Phone</label><br>' +
        '<input id="swal-input-notelp" class="custom-input fontSize-16 " placeholder="Input Your Number Phone">',
      focusConfirm: false,
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText:
        '<i class="fa fa-thumbs-up"></i> OK',
      confirmButtonAriaLabel: 'Thumbs up, great!',
      cancelButtonText:
        '<i class="fa fa-thumbs-down">Batal</i>',
      cancelButtonAriaLabel: 'Thumbs down',
      preConfirm: () => {
        const email = document.getElementById('swal-input-email').value
        const name = document.getElementById('swal-input-name').value
        const notelp = document.getElementById('swal-input-notelp').value
        if (name == "" ) {
          Swal.showValidationMessage('Input Your Name First!')
        } else if (email == "" ) {
          Swal.showValidationMessage('Input Your Email First!')
        } else if (notelp == "" ) {
          Swal.showValidationMessage('Input Your Phone First!')
        } else {
          generateVABisnis(selectedBank.bank.kodeBank, email, name, notelp);
        }
      }
    })
  }
 
  const alertConfirm = () => {
    swal({
      title: "Are you sure to proceed?",
      icon: icons(iconName.warningDialog),
      text:
        "After you press the confirmation button, you cannot change the payment method again",
      buttons: {
        cancel: true,
        confirm: {
          value: "confirm",
          text: "Confirm",
          className: "swal-red-btn",
        },
      },
    }).then((onConfirm) => {
      if (onConfirm === "confirm") {
        if(initial.type_user == "BISNIS") {
          // inputDataUser()
          generateVABisnis(selectedBank.bank.kodeBank, formData.email, formData.name, formData.phone);
        } else {
          inputEmailUser() 
        }
      } else {
        swal.close();
      }
    });
  };

  const doConfirm = () => {
    const { name, email, phone } = formData;

    if (name.trim() === '') {
      swal({
        icon: 'error',
        title: 'Oops...',
        text: 'Nama tidak boleh kosong!',
      });
    } else if (email.trim() === '') {
      swal({
        icon: 'error',
        title: 'Oops...',
        text: 'Email tidak boleh kosong!',
      });
    } else if (phone.trim() === '') {
      swal({
        icon: 'error',
        title: 'Oops...',
        text: 'No Handphone tidak boleh kosong!',
      });
    } else {
      alertConfirm();
    }
  }

  return (
    <div 
      style={{
        background: "white",
        backgroundImage: `url(${BANNER})`,
        backgroundSize: '391.31px 387.63px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left bottom',
        backgroundAttachment: 'fixed',
        height: 'auto'
      }}
    >
      <div
        className="cust-header"
        style={{
          background: "white",
          height: 80,
          width: "100%",
          boxShadow: "0px 1px 12px rgba(0, 0, 0, 0.07)"
        }}
      >
        <Container className="container-header-payment-public">
          {process.env.REACT_APP_BRAND === 'FUSINDO' ? (<>
            <img alt="LinkQu Logo" src={`${process.env.PUBLIC_URL}/logo192-fusindo.png`} className="logo-brand"/>
          </>) : (<>
            <img alt="LinkQu Logo" src={LinkquLogo} className="logo-brand"/>
          </>)}
          <div className="fontSizeManrope-22 text-right" style={{ color: '#555555' }}>
          Invoice Payment Link
          </div>
        </Container>
      </div>
      {initial.loading ? (
        <Container
          className="loading-wrapper d-flex justify-content-center align-items-center w-100"
          style={{ height: "90vh" }}
        >
          <div className="loading-state d-flex">
            <Spinner
              size="xl"
              className="mx-2 text-active"
              animation="grow"
            />
            <Spinner
              size="xl"
              className="mx-2 text-active"
              animation="grow"
            />
            <Spinner
              size="xl"
              className="mx-2 text-active"
              animation="grow"
            />
          </div>
        </Container>
      ) : initial.data == null ? (
        <Container
          className="container-payment-public"
        >
          <div
            className="content-wrapper"
          >
            <div className="d-flex flex-column align-items-center p-5">
              <img src={icons(iconName.limitLogo, process.env.REACT_APP_BRAND_NAME)} alt="Limit Logo" style={{ width: "50%", marginBottom: 20 }} />
              <h5 style={{ textAlign: "center" }}>Data not found</h5>
            </div>
          </div>
        </Container>
      ) : (
        <Container
          className="container-payment-public"
        >
          <div
            className=""
          >
            {
              isExpired(initial.data.timeExpired) ? 
              (
                <div className="d-flex flex-column align-items-center p-5">
                  <img src={icons(iconName.limitLogo, process.env.REACT_APP_BRAND_NAME)} alt="Limit Logo" style={{ width: "50%", marginBottom: 20 }} />
                  <h5 style={{ textAlign: "center" }}>This Request Payment Already Expired At <br /> {DateTime.format(initial.data.timeExpired, DateTime.FMT_DATE_TIME_YMDHMS3)} WIB.</h5>
                </div>
              ) : (
                initial.data.count >= initial.data.number ? 
                (
                  <div className="d-flex flex-column align-items-center p-5">
                    <img src={icons(iconName.limitLogo, process.env.REACT_APP_BRAND_NAME)} alt="Limit Logo" style={{ width: "50%", marginBottom: 20 }} />
                    <h5 style={{ textAlign: "center" }}>This Request Payment Already Reached the Maximum Usage Limit.</h5>
                  </div>
                ) : 
                (
                  <>
                    <div className="body-content-wrapper">
                      <div className="main-content">
                        {mainContent.detailContent && (
                          <DetailPayment
                            dataPayment={initial}
                            mainState={initial}
                            changeMainState={changeInitial}
                            selectedBank={selectedBank}
                            disableButtonPay={disableButtonPay}
                            disableButtonPayState={disableButtonPayState}
                            selectedBankState={selectedBankState}
                            action={doConfirm}
                            activeCategory={activeCategory}
                            setActiveCategory={setActiveCategory} 
                            formData={formData} 
                            setFormData={setFormData} 
                          />
                        )}
                        {mainContent.createdVa && (
                          <CreatedVAContent selectedBank={selectedBank} dataPayment={initial} dataVA={initial.successGeneratedVAData} emailUser={emailUser} />
                        )}
                      </div>
                    </div>
                  </>
                )
              )
            }
          </div>
        </Container>
      )}
      <AlertDialog
        show={!!initial.alertError}
        onHide={closeError}
        onConfirm={closeError}
        title="Perhatian"
      >
        {initial.alertError}
      </AlertDialog>
    </div>
  );
};

const DetailPayment = ({ dataPayment, action, selectedBank, selectedBankState, disableButtonPay, disableButtonPayState, activeCategory, setActiveCategory, formData, setFormData }) => {
  const descHTMLContent = (contentHMTL) => {
    return {
      __html: DOMPurify.sanitize(contentHMTL),
    };
  };
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);

  const [localName, setLocalName] = useState(formData.name);
  const [localEmail, setLocalEmail] = useState(formData.email);
  const [localPhone, setLocalPhone] = useState(formData.phone);

  useEffect(() => {
    if (nameRef.current) {
      nameRef.current.focus();
    }
  }, [formData.name]);

  useEffect(() => {
    if (emailRef.current) {
      emailRef.current.focus();
    }
  }, [formData.email]);

  useEffect(() => {
    if (phoneRef.current) {
      phoneRef.current.focus();
    }
  }, [formData.phone]);

  const handleNameChange = (e) => {
    setLocalName(e.target.value);
    setFormData({ ...formData, name: e.target.value });
  };

  const handleEmailChange = (e) => {
    setLocalEmail(e.target.value);
    setFormData({ ...formData, email: e.target.value });
  };

  const handlePhoneChange = (e) => {
    setLocalPhone(e.target.value);
    setFormData({ ...formData, phone: e.target.value });
  };

  const DetailContent = ({ payment, banks, actions, selectedBankStates, selectedBanks,disableButton, disableButtonPayStates }) => {
    const date = DateTime.parse(
      payment?.timeExpired,
      DateTime.FMT_DATE_TIME_YMDHMS
    ).toDate();
    const dateCreate = DateTime.parse(
      payment?.timeRequest,
      DateTime.FMT_DATE_TIME_YMDHMS
    ).toDate();
    // const [activeCategory, setActiveCategory] = useState('virtual');

    // Pisahkan kategori
    const virtualBanks = banks.filter(b => b.isActive && !['QRIS', 'ALFAMART', 'INDOMARET', 'QRISB', 'PAYDANA', 'PAYOVO', '', 'PAYSHOPEE', 'CREDITCARD'].includes(b.kodeBank));
    const qrisBanks = banks.filter(b => b.isActive && ['QRIS', 'QRISB', 'PAYDANA', 'PAYOVO', 'PAYLINKAJA', 'PAYSHOPEE'].includes(b.kodeBank));
    const retailBanks = banks.filter(b => b.isActive && (b.kodeBank === 'ALFAMART' || b.kodeBank === 'INDOMARET'));
    const creditBanks = banks.filter(b => b.isActive && b.kodeBank === 'CREDITCARD');
    const getBankLogo = (bank) => {
      const nama = bank.namaBank?.toUpperCase();
      if (nama === 'ALFAMART') return alfaLogo;
      if (nama === 'INDOMARET') return indoLogo;
      if (nama === 'CREDITCARD') return creditLogo;
      if (bank.url_image) return bank.url_image;
      return icons(iconName.gubuk);
    };
    
    const renderBankLogos = (bankList) => (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
        {bankList.map(bank => (
          <div
            key={bank.kodeBank}
            className={`card-payment-logo-only ${selectedBanks.bank?.kodeBank === bank.kodeBank ? 'card-payment-active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              disableButtonPayStates({ disabled: !selectedBankStates });
              selectedBankStates({ bank });
            }}
            style={{
              padding: 2,
              border: '1px solid #F4F2F2',
              borderRadius: 4,
              cursor: 'pointer',
              backgroundColor: '#FFFFFF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 95,
              height: 45,
            }}
          >
            <img
              src={getBankLogo(bank)}
              alt={bank.namaBank}
              style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
            />
          </div>
        ))}
      </div>
    );

    return (
      <Row className="g-8">
        <Col md="6" sm="12" xs="12" className="mb-4 px-3">
          <div className="wrapper-detail mb-5" style={{ paddingBottom: 10 }}>
            {/* <div className="detail-full">
              <div className="pt-3 pl-3 fontSize-16-Medium">
                Detail Payment
              </div>
              <hr />
              <Row>
                <Col sm="6" xs="12">
                  <div className="pl-3 fontSize-16-Medium color-grey">
                    Payment Name:
                  </div>
                </Col>
                <Col sm="6" xs="12">
                  <div className="pr-3 fontSize-16-Medium text-right">
                    {payment?.namePayment}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm="6" xs="12">
                  <div className="pl-3 fontSize-16-Medium color-grey">
                    Amount:
                  </div>
                </Col>
                <Col sm="6" xs="12">
                  <div className="pr-3 fontSize-16-Medium text-right">
                    {Formatter.price(!!payment.totalAmount ? payment.totalAmount : payment.amount)}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm="6" xs="12">
                  <div className="pl-3 fontSize-16-Medium color-grey">
                    Payment Expired:
                  </div>
                </Col>
                <Col sm="6" xs="12">
                  <div className="pr-3 fontSize-16-Medium text-right">
                    {DateTime.format(date, DateTime.FMT_DATE_TIME_YMDHMS)}
                  </div>
                </Col>
              </Row>
              <div className="pl-3 fontSize-16-Medium color-grey">Payment Description: </div>
              {payment?.descPayment === "" ? (
                  <div className="pb-5" />
                ) : (
                  <div
                    dangerouslySetInnerHTML={descHTMLContent(payment?.descPayment)}
                    className="pb-5 pl-3 fontSize-16-Medium"
                  ></div>
                )}
            </div> */}
            <div style={{ textAlign: "center", paddingTop: '26px' }}>
            <div>
              <span className="fontSize-12-manrope" style={{ color: '#696969' }}>Bayar Sebelum {DateTime.format(date, DateTime.FMT_DATE_TIME_DMY)} | {DateTime.format(date, DateTime.FMT_TIME_HM)}</span>
            </div>
            <div>
              <span className="fontSizeManrope-24" style={{ color:'#FF0000' }}>IDR {Formatter.price(!!payment.totalAmount ? payment.totalAmount : payment.amount)}</span>
            </div>
            </div>

            <div style={{ padding: 20, backgroundColor: '#FFFFFF', borderRadius: 10, maxWidth: '100%' }}>
              {/* Virtual Account Section */}
              <div style={{ marginBottom: 20 }}>
              <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    paddingBottom: 6,
                    gap: 10
                  }}
                  onClick={() => setActiveCategory('virtual')}
                >
                  <span className="fontSize-12-manrope" style={{ whiteSpace: 'nowrap', color: '#696969' }}>Virtual Account</span>
                  <hr style={{ flexGrow: 1, border: 'none', borderTop: '1px solid #E9E9E9', margin: 5 }} />
                  <Image src={activeCategory === 'virtual' ? icons(iconName.epDown) : icons(iconName.epRight)} style={{ height: '15px', width: '17px', objectFit: 'contain'}}/>
                </div>
                {activeCategory === 'virtual' && (
                  <>
                    {renderBankLogos(virtualBanks)}
                    <div style={{ marginTop: 15 }}>
                      <div className="form-group">
                        <span>Nama</span>
                        <input
                          ref={nameRef}
                          type="text"
                          className="input-field"
                          value={localName}
                          onChange={handleNameChange}
                        />
                      </div>

                      <div className="form-group">
                        <span>Email</span>
                        <input
                          ref={emailRef}
                          type="email"
                          className="input-field"
                          value={localEmail}
                          onChange={handleEmailChange}
                        />
                      </div>

                      <div className="form-group">
                        <span>Nomor Handphone</span>
                        <input
                          ref={phoneRef}
                          type="number"
                          className="input-field"
                          value={localPhone}
                          onChange={handlePhoneChange}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>

              {/* QRIS Section */}
              <div style={{ marginBottom: 20 }}>
                <div
                  style={{  display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    paddingBottom: 6,
                    gap: 10}}
                  onClick={() => setActiveCategory('qris')}
                >
                  <span className="fontSize-12-manrope" style={{ whiteSpace: 'nowrap', color: '#696969' }}>QRIS & Ewallet</span>
                  <hr style={{ flexGrow: 1, border: 'none', borderTop: '1px solid #E9E9E9', margin: 5 }} />
                  <Image src={activeCategory === 'qris' ? icons(iconName.epDown) : icons(iconName.epRight)} style={{ height: '15px', width: '17px', objectFit: 'contain'}}/>
                </div>
                {activeCategory === 'qris' && (
                  <>
                    {renderBankLogos(qrisBanks)}
                    <div style={{ marginTop: 15 }}>
                      <div className="form-group">
                        <span>Nama</span>
                        <input
                          ref={nameRef}
                          type="text"
                          className="input-field"
                          value={localName}
                          onChange={handleNameChange}
                        />
                      </div>

                      <div className="form-group">
                        <span>Email</span>
                        <input
                          ref={emailRef}
                          type="email"
                          className="input-field"
                          value={localEmail}
                          onChange={handleEmailChange}
                        />
                      </div>

                      <div className="form-group">
                        <span>Nomor Handphone</span>
                        <input
                          ref={phoneRef}
                          type="number"
                          className="input-field"
                          value={localPhone}
                          onChange={handlePhoneChange}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>

              {/* Retail Section */}
              <div style={{ marginBottom: 20 }}>
                <div
                  style={{  display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    paddingBottom: 6,
                    gap: 10}}
                  onClick={() => setActiveCategory('retail')}
                >
                  <span className="fontSize-12-manrope" style={{ whiteSpace: 'nowrap', color: '#696969' }}>Retail</span>
                  <hr style={{ flexGrow: 1, border: 'none', borderTop: '1px solid #E9E9E9', margin: 5 }} />
                  <Image src={activeCategory === 'retail' ? icons(iconName.epDown) : icons(iconName.epRight)} style={{ height: '15px', width: '17px', objectFit: 'contain'}}/>
                </div>
                {activeCategory === 'retail' && (
                  <>
                    {renderBankLogos(retailBanks)}
                    <div style={{ marginTop: 15 }}>
                      <div className="form-group">
                        <span>Nama</span>
                        <input
                          ref={nameRef}
                          type="text"
                          className="input-field"
                          value={localName}
                          onChange={handleNameChange}
                        />
                      </div>

                      <div className="form-group">
                        <span>Email</span>
                        <input
                          ref={emailRef}
                          type="email"
                          className="input-field"
                          value={localEmail}
                          onChange={handleEmailChange}
                        />
                      </div>

                      <div className="form-group">
                        <span>Nomor Handphone</span>
                        <input
                          ref={phoneRef}
                          type="number"
                          className="input-field"
                          value={localPhone}
                          onChange={handlePhoneChange}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
              {/* creditcard Section */}
              <div>
                <div
                  style={{  display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    paddingBottom: 6,
                    gap: 10}}
                  onClick={() => setActiveCategory('credit')}
                >
                  <span className="fontSize-12-manrope" style={{ whiteSpace: 'nowrap', color: '#696969' }}>Kartu Kredit</span>
                  <hr style={{ flexGrow: 1, border: 'none', borderTop: '1px solid #E9E9E9', margin: 5 }} />
                  <Image src={activeCategory === 'credit' ? icons(iconName.epDown) : icons(iconName.epRight)} style={{ height: '15px', width: '17px', objectFit: 'contain'}}/>
                </div>
                {activeCategory === 'credit' && (
                  <>
                    {renderBankLogos(creditBanks)}
                    <div style={{ marginTop: 15 }}>
                      <div className="form-group">
                        <span>Nama</span>
                        <input
                          ref={nameRef}
                          type="text"
                          className="input-field"
                          value={localName}
                          onChange={handleNameChange}
                        />
                      </div>

                      <div className="form-group">
                        <span>Email</span>
                        <input
                          ref={emailRef}
                          type="email"
                          className="input-field"
                          value={localEmail}
                          onChange={handleEmailChange}
                        />
                      </div>

                      <div className="form-group">
                        <span>Nomor Handphone</span>
                        <input
                          ref={phoneRef}
                          type="number"
                          className="input-field"
                          value={localPhone}
                          onChange={handlePhoneChange}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div style={{ width:'90%', justifySelf:'center'}}>
              <Button
                type="submit"
                size="md"
                variant="primary"
                block
                onClick={actions}
                className="btn-custom btn-custom-reset-password button-desktop"
                disabled={disableButton.disabled}
                style={{ borderRadius:'4px' }}
              >
                <div className="fontSize-12-manrope color-white">Bayar Sekarang</div>
              </Button>
            </div>
          </div>
        </Col>
        <Col md="6" sm="12" xs="12">
          <div className="wrapper-detail">
          <div className="detail-full" style={{ paddingBottom:'22px' }}>
              <div className="pt-3 pl-4" style={{ paddingBottom: "20px" }}>
                <span className="fontSizeManrope-16-Bold" style={{ color: '#555555' }}>Detail Pembayaran</span>
              </div>
              <div className="pl-4 fontSize-12-manrope" style={{ color:'#555555',paddingBottom:'2px' }}>
                 Keperluan transfer
              </div>
              <div className="pl-4 fontSize-12-manrope-small" style={{ color:'#555555', paddingBottom:'10px' }}>
                {payment?.namePayment}
              </div>
              {/* <Row>
                <Col sm="6" xs="12"> */}
                <div className="pl-4 fontSize-12-manrope" style={{ color:'#555555', paddingBottom:'2px' }}>
                  Keterangan
                </div>
                {/* </Col>
                <Col sm="6" xs="12"> */}
                <div className="pl-4 fontSize-12-manrope-small" style={{ color:'#555555' }}>
                  {payment?.descPayment}
                </div>
                {/* </Col>
              </Row> */}
              <Row style={{ padding: '10px', backgroundColor:'#FFC6C6', width: '90%', maxWidth: '304px', marginLeft: '22px', marginTop: '15px', borderRadius:'8px' }}>
                <Col sm="6" xs="12">
                  <div className="pl-2 fontSize-12-manrope-small" style={{ color:'#555555', paddingTop:'2px' }}>
                    Tanggal dibuat
                  </div>
                </Col>
                <Col sm="6" xs="12">
                  <div className="pr-2 fontSize-12-manrope text-right">
                    : {DateTime.format(dateCreate, DateTime.FMT_DATE_YMD)} | {DateTime.format(dateCreate, DateTime.FMT_TIME_HM)}
                  </div>
                </Col>
                <Col sm="6" xs="12">
                  <div className="pl-2 fontSize-12-manrope-small" style={{ color:'#555555', paddingTop:'2px' }}>
                    Tanggal kedaluarsa
                  </div>
                </Col>
                <Col sm="6" xs="12">
                  <div className="pr-2 fontSize-12-manrope text-right">
                    : {DateTime.format(date, DateTime.FMT_DATE_YMD)} | {DateTime.format(date, DateTime.FMT_TIME_HM)}
                  </div>
                </Col>
              </Row>
          </div>
          </div>
        </Col>
        {/* <Button
          type="submit"
          size="md"
          variant="primary"
          block
          onClick={actions}
          className="btn-custom btn-custom-reset-password fontSize-17 button-mobile"
        >
          <div className="fontSize-17 color-white">Pay</div>
          <Image src={icons(iconName.arrowWhite)} className="ml-5" />
        </Button> */}
        <Button
          type="submit"
          size="md"
          variant="primary"
          block
          onClick={actions}
          className="btn-custom btn-custom-reset-password button-mobile"
          disabled={disableButton.disabled}
          style={{ borderRadius:'4px' }}
        >
          <div className="fontSize-12-manrope color-white">Bayar Sekarang</div>
        </Button>
      </Row>
    );
  };

  return (
    <div>
      {/* <div className="id-order fontSize-17 text-active">
        ORDER ID {dataPayment.data.id}
      </div> */}
      <DetailContent selectedBanks={selectedBank} disableButton={disableButtonPay} disableButtonPayStates={disableButtonPayState} selectedBankStates={selectedBankState} payment={dataPayment.data} banks={dataPayment.dataBank} actions={action} />
    </div>
  );
};

function parseExpiredTime(expiredTimeStr) {
  const year = expiredTimeStr.slice(0, 4);
  const month = expiredTimeStr.slice(4, 6);
  const day = expiredTimeStr.slice(6, 8);
  const hour = expiredTimeStr.slice(8, 10);
  const minute = expiredTimeStr.slice(10, 12);
  const second = expiredTimeStr.slice(12, 14);

  return new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
}

function copyText(text, data) {
  navigator.clipboard.writeText(data)
  swal('Sukses', `${text}`, 'success')
}

const CreatedVAContent = ({ selectedBank ,dataPayment, dataVA, emailUser }) => {
  const isQris = dataVA?.kodBank === 'QRIS' || dataVA?.kodBank === 'QRISB'
  const hasLinkPaymentExternal = dataVA?.kodBank === 'CREDITCARD' || dataVA?.kodBank === 'PAYDANA' || dataVA?.kodBank === 'PAYSHOPEE' || dataVA?.kodBank === 'PAYLINKAJA'
  const retail = dataVA?.kodBank === 'ALFAMART' || dataVA?.kodBank === 'INDOMARET'
  const date = DateTime.parse(
    dataPayment?.data.timeExpired,
    DateTime.FMT_DATE_TIME_YMDHMS
  ).toDate();
  const dateCreate = DateTime.parse(
    dataPayment?.data.timeRequest,
    DateTime.FMT_DATE_TIME_YMDHMS
  ).toDate();
  const countdate = DateTime.parse(
    dataPayment?.data.timeExpired,
    DateTime.FMT_DATE_TIME_YMDHMS_NS
  ).toDate();

  const bank = dataPayment.dataBank.find(item => item.kodeBank === dataVA?.kodBank);
  const boxStyle = {
    backgroundColor: '#FF0000',
    color: '#FFFFFF',
    padding: '3px',
    margin: '2px',
    borderRadius: '3px',
    display: 'inline-block',
    width: '22px',
    textAlign: 'center'
  };
  
  const logoMap = {
    ALFAMART: alfaLogo,
    INDOMARET: indoLogo,
    CREDITCARD: creditLogo
  };

  const targetDate = parseExpiredTime(DateTime.format(countdate, DateTime.FMT_DATE_TIME_YMDHMS_NS));

  const [activeTab, setActiveTab] = useState('ATM');
  const guide = paymentInstructions[dataVA?.kodBank] || {};

  return (
    <>
      <div className="container-generatedva" style={{ height: '130vh' }}>
        {/* <div className="text-right">
          <div className="id-order fontSize-17 text-active mb-3">
            ORDER ID {dataPayment.data.id}
          </div>
        </div> */}
        <Row>
          <Col md="6" sm="12" xs="12">
            {!isQris && !hasLinkPaymentExternal && retail && (<div>
              {/* <div className="fontSize-19-Bold">
                Virtual Account Detail
              </div>
              <div className="detail-va">
                <Row>
                  <Col sm="6" xs="12">
                    <div className="pl-3 fontSize-16-Medium color-grey">
                      VA Number:
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pr-3 fontSize-16-Medium text-right">
                      {dataVA?.vaNumber}
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pl-3 fontSize-16-Medium color-grey">
                      VA Name:
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pr-3 fontSize-16-Medium text-right">
                      {dataVA?.customerName}
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pl-3 fontSize-16-Medium color-grey">
                      Amount:
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pr-3 fontSize-16-Medium text-right">
                      {Formatter.price(!!dataPayment.totalAmount ? dataPayment.totalAmount : dataPayment.data?.amount)}
                    </div>
                  </Col>
                </Row>
              </div> */}
              <div className="wrapper-detail mb-5" style={{ paddingBottom: 10 }}>
              
                <div className="pl-4 pr-4" style={{paddingTop: '20px' }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 0'
                }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    <div>
                      <span className="fontSizeManrope-22" style={{ color: '#555555' }}>Bayar Sebelum </span>
                    </div>
                    <div>
                      <span className="fontSizeManrope-14-Bold" style={{ color: '#555555' }}>{DateTime.format(date, DateTime.FMT_DATE_TIME_DMY)} | {DateTime.format(date, DateTime.FMT_TIME_HM)}</span>
                    </div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <Countdown
                      date={targetDate}
                      renderer={({ hours, minutes, seconds, completed }) => {
                        if (completed) {
                          return (
                            <div>
                              {/* Baris angka */}
                              <div className="fontSize-12-manrope-small" style={{ color:'#FF0000' }}>
                                <span style={boxStyle}>00</span>:
                                <span style={boxStyle}>00</span>:
                                <span style={boxStyle}>00</span>
                              </div>
                              {/* Baris label */}
                              <div className="fontSizeManrope-8" style={{ marginTop: '4px', color: '#555555' }}>
                                <span style={{ width: '30px', display: 'inline-block' }}>Jam</span>
                                <span style={{ width: '30px', display: 'inline-block' }}>Menit</span>
                                <span style={{ width: '30px', display: 'inline-block' }}>Detik</span>
                              </div>
                            </div>
                          );
                        } 
                          return (
                            <div>
                              {/* Baris angka */}
                              <div className="fontSize-12-manrope-small" style={{ color:'#FF0000' }}>
                                <span style={boxStyle}>{String(hours).padStart(2, '0')}</span>:
                                <span style={boxStyle}>{String(minutes).padStart(2, '0')}</span>:
                                <span style={boxStyle}>{String(seconds).padStart(2, '0')}</span>
                              </div>
                              {/* Baris label */}
                              <div className="fontSizeManrope-8" style={{ marginTop: '4px', color: '#555555', textAlign:'center' }}>
                                <span style={{ width: '30px', display: 'inline-block' }}>Jam</span>
                                <span style={{ width: '30px', display: 'inline-block' }}>Menit</span>
                                <span style={{ width: '30px', display: 'inline-block' }}>Detik</span>
                              </div>
                            </div>
                          );
                        
                      }}
                    />
                  </div>

                </div>
                <hr />
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 0'
                }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    <span className="fontSizeManrope-16" style={{ color: '#555555' }}>
                      Total Tagihan
                    </span>
                    <span className="fontSizeManrope-20-Bold" style={{ color: '#555555' }}>
                      IDR {Formatter.price(!!dataPayment.totalAmount ? dataPayment.totalAmount : dataPayment.amount)}
                    </span>
                  </div>

                  <img
                    src={logoMap[dataVA?.kodBank] || icons(iconName.gubuk)}
                    alt="Logo"
                    width="121"
                    height="45"
                    style={{ objectFit: 'contain' }}
                  />
                </div>

                <div style={{ paddingTop:'5px' }}>
                  <Barcode value={dataVA?.vaNumber} />
                </div>
                <div>
                  <span className="fontSize-12-manrope-small" style={{ color: '#555555' }}>Scan kode QR / download QR / screenshoot QR dibawah ini dan berikan kode <br /> berikut ke kasir</span>
                </div>
                </div>

              </div>
            </div>)}
            {!isQris && hasLinkPaymentExternal && !retail && (<div>
              {/* <div className="fontSize-19-Bold">
                Credit Card Detail
              </div>
              <div className="detail-va">
                <Row>
                  <Col sm="6" xs="12">
                    <div className="pl-3 fontSize-16-Medium color-grey">
                      Customer Name:
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pr-3 fontSize-16-Medium text-right">
                      {dataVA?.customerName}
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pl-3 fontSize-16-Medium color-grey">
                    Customer Email:
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pr-3 fontSize-16-Medium text-right">
                      {dataVA?.email}
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pl-3 fontSize-16-Medium color-grey">
                      Amount:
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pr-3 fontSize-16-Medium text-right">
                      {Formatter.price(!!dataPayment.totalAmount ? dataPayment.totalAmount : dataPayment.data?.amount)}
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pl-3 fontSize-16-Medium color-grey">
                      Fee Admin:
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pr-3 fontSize-16-Medium text-right">
                      {Formatter.price(dataVA?.feeadmin)}
                    </div>
                  </Col> */}
                  <div className="wrapper-detail mb-5" style={{ paddingBottom: 10 }}>
                    <div className="pl-4 pr-4" style={{paddingTop: '20px' }}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '8px 0'
                    }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <div>
                          <span className="fontSizeManrope-22" style={{ color: '#555555' }}>Bayar Sebelum </span>
                        </div>
                        <div>
                          <span className="fontSizeManrope-14-Bold" style={{ color: '#555555' }}>{DateTime.format(date, DateTime.FMT_DATE_TIME_DMY)} | {DateTime.format(date, DateTime.FMT_TIME_HM)}</span>
                        </div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <Countdown
                          date={targetDate}
                          renderer={({ hours, minutes, seconds, completed }) => {
                            if (completed) {
                              return (
                                <div>
                                  {/* Baris angka */}
                                  <div className="fontSize-12-manrope-small" style={{ color:'#FF0000' }}>
                                    <span style={boxStyle}>00</span>:
                                    <span style={boxStyle}>00</span>:
                                    <span style={boxStyle}>00</span>
                                  </div>
                                  {/* Baris label */}
                                  <div className="fontSizeManrope-8" style={{ marginTop: '4px', color: '#555555' }}>
                                    <span style={{ width: '30px', display: 'inline-block' }}>Jam</span>
                                    <span style={{ width: '30px', display: 'inline-block' }}>Menit</span>
                                    <span style={{ width: '30px', display: 'inline-block' }}>Detik</span>
                                  </div>
                                </div>
                              );
                            } 
                              return (
                                <div>
                                  {/* Baris angka */}
                                  <div className="fontSize-12-manrope-small" style={{ color:'#FF0000' }}>
                                    <span style={boxStyle}>{String(hours).padStart(2, '0')}</span>:
                                    <span style={boxStyle}>{String(minutes).padStart(2, '0')}</span>:
                                    <span style={boxStyle}>{String(seconds).padStart(2, '0')}</span>
                                  </div>
                                  {/* Baris label */}
                                  <div className="fontSizeManrope-8" style={{ marginTop: '4px', color: '#555555', textAlign:'center' }}>
                                    <span style={{ width: '30px', display: 'inline-block' }}>Jam</span>
                                    <span style={{ width: '30px', display: 'inline-block' }}>Menit</span>
                                    <span style={{ width: '30px', display: 'inline-block' }}>Detik</span>
                                  </div>
                                </div>
                              );
                            
                          }}
                        />
                      </div>

                    </div>
                    <hr />
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '8px 0'
                    }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <span className="fontSizeManrope-16" style={{ color: '#555555' }}>
                          Total Tagihan
                        </span>
                        <span className="fontSizeManrope-20-Bold" style={{ color: '#555555' }}>
                          IDR {Formatter.price(!!dataPayment.totalAmount ? dataPayment.totalAmount : dataPayment.amount)}
                        </span>
                      </div>

                      <img
                        src={logoMap[dataVA?.kodBank] || icons(iconName.gubuk)}
                        alt="Logo"
                        width="121"
                        height="45"
                        style={{ objectFit: 'contain' }}
                      />
                    </div>
                    </div>
                    <div style={{ width:'90%', justifySelf:'center'}}>
                      <a
                        href={dataVA?.linkPayment}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Button
                          type="submit"
                          size="md"
                          variant="primary"
                          block
                          className="btn-custom btn-custom-reset-password button-desktop"
                          style={{ borderRadius:'4px' }}
                        >
                          <div className="fontSize-12-manrope color-white">Bayar Sekarang</div>
                          {/* <Image src={icons(iconName.arrowWhite)} className="ml-5" /> */}
                        </Button>
                      </a>
                    </div>
                  </div>
                {/* </Row>
              </div> */}
            </div>)}
            {isQris && (
              <div className="d-flex w-100 mb-3 flex-column align-items-center justify-content-center">
                {/* <img src={QrisLogo} alt="QR CODE LOGO" width="200px" height="100px"/>
                <img src={`data:image/png;base64,${ dataVA?.imageQris}`} alt="QR CODE" width="200px" height="200px"/> */}
                <div className="wrapper-detail mb-5" style={{ paddingBottom: 10 }}>
              
                  <div className="pl-4 pr-4" style={{paddingTop: '20px' }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '8px 0'
                  }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                      <div>
                        <span className="fontSizeManrope-22" style={{ color: '#555555' }}>Bayar Sebelum </span>
                      </div>
                      <div>
                        <span className="fontSizeManrope-14-Bold" style={{ color: '#555555' }}>{DateTime.format(date, DateTime.FMT_DATE_TIME_DMY)} | {DateTime.format(date, DateTime.FMT_TIME_HM)}</span>
                      </div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <Countdown
                        date={targetDate}
                        renderer={({ hours, minutes, seconds, completed }) => {
                          if (completed) {
                            return (
                              <div>
                                {/* Baris angka */}
                                <div className="fontSize-12-manrope-small" style={{ color:'#FF0000' }}>
                                  <span style={boxStyle}>00</span>:
                                  <span style={boxStyle}>00</span>:
                                  <span style={boxStyle}>00</span>
                                </div>
                                {/* Baris label */}
                                <div className="fontSizeManrope-8" style={{ marginTop: '4px', color: '#555555' }}>
                                  <span style={{ width: '30px', display: 'inline-block' }}>Jam</span>
                                  <span style={{ width: '30px', display: 'inline-block' }}>Menit</span>
                                  <span style={{ width: '30px', display: 'inline-block' }}>Detik</span>
                                </div>
                              </div>
                            );
                          } 
                            return (
                              <div>
                                {/* Baris angka */}
                                <div className="fontSize-12-manrope-small" style={{ color:'#FF0000' }}>
                                  <span style={boxStyle}>{String(hours).padStart(2, '0')}</span>:
                                  <span style={boxStyle}>{String(minutes).padStart(2, '0')}</span>:
                                  <span style={boxStyle}>{String(seconds).padStart(2, '0')}</span>
                                </div>
                                {/* Baris label */}
                                <div className="fontSizeManrope-8" style={{ marginTop: '4px', color: '#555555', textAlign:'center' }}>
                                  <span style={{ width: '30px', display: 'inline-block' }}>Jam</span>
                                  <span style={{ width: '30px', display: 'inline-block' }}>Menit</span>
                                  <span style={{ width: '30px', display: 'inline-block' }}>Detik</span>
                                </div>
                              </div>
                            );
                          
                        }}
                      />
                    </div>

                  </div>
                  <hr />
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '8px 0'
                  }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                      <span className="fontSizeManrope-16" style={{ color: '#555555' }}>
                        Total Tagihan
                      </span>
                      <span className="fontSizeManrope-20-Bold" style={{ color: '#555555' }}>
                        IDR {Formatter.price(!!dataPayment.totalAmount ? dataPayment.totalAmount : dataPayment.amount)}
                      </span>
                    </div>

                    <img
                      src={QrisLogo}
                      alt="Logo"
                      width="57"
                      height="22"
                      style={{ objectFit: 'contain' }}
                    />
                  </div>

                  <div style={{ paddingTop:'5px' }}>
                    <img src={`data:image/png;base64,${ dataVA?.imageQris}`} alt="QR CODE" width="200px" height="200px"/>
                  </div>
                  <div>
                    <span className="fontSize-12-manrope-small" style={{ color: '#555555' }}>Scan kode QR / download QR / screenshoot QR dibawah ini dan berikan kode <br /> berikut ke kasir</span>
                  </div>
                  </div>

                </div>
              </div>
          )}
          {!isQris && !hasLinkPaymentExternal && !retail && (
              <div className="d-flexmb-3 flex-column align-items-center justify-content-center">
                
                <div className="wrapper-detail mb-5" style={{ paddingBottom: 10 }}>
              
                  <div className="pl-4 pr-4" style={{paddingTop: '20px' }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '8px 0'
                  }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                      <div>
                        <span className="fontSizeManrope-22" style={{ color: '#555555' }}>Bayar Sebelum </span>
                      </div>
                      <div>
                        <span className="fontSizeManrope-14-Bold" style={{ color: '#555555' }}>{DateTime.format(date, DateTime.FMT_DATE_TIME_DMY)} | {DateTime.format(date, DateTime.FMT_TIME_HM)}</span>
                      </div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <Countdown
                        date={targetDate}
                        renderer={({ hours, minutes, seconds, completed }) => {
                          if (completed) {
                            return (
                              <div>
                                {/* Baris angka */}
                                <div className="fontSize-12-manrope-small" style={{ color:'#FF0000' }}>
                                  <span style={boxStyle}>00</span>:
                                  <span style={boxStyle}>00</span>:
                                  <span style={boxStyle}>00</span>
                                </div>
                                {/* Baris label */}
                                <div className="fontSizeManrope-8" style={{ marginTop: '4px', color: '#555555' }}>
                                  <span style={{ width: '30px', display: 'inline-block' }}>Jam</span>
                                  <span style={{ width: '30px', display: 'inline-block' }}>Menit</span>
                                  <span style={{ width: '30px', display: 'inline-block' }}>Detik</span>
                                </div>
                              </div>
                            );
                          } 
                            return (
                              <div>
                                {/* Baris angka */}
                                <div className="fontSize-12-manrope-small" style={{ color:'#FF0000' }}>
                                  <span style={boxStyle}>{String(hours).padStart(2, '0')}</span>:
                                  <span style={boxStyle}>{String(minutes).padStart(2, '0')}</span>:
                                  <span style={boxStyle}>{String(seconds).padStart(2, '0')}</span>
                                </div>
                                {/* Baris label */}
                                <div className="fontSizeManrope-8" style={{ marginTop: '4px', color: '#555555', textAlign:'center' }}>
                                  <span style={{ width: '30px', display: 'inline-block' }}>Jam</span>
                                  <span style={{ width: '30px', display: 'inline-block' }}>Menit</span>
                                  <span style={{ width: '30px', display: 'inline-block' }}>Detik</span>
                                </div>
                              </div>
                            );
                          
                        }}
                      />
                    </div>

                  </div>
                  <hr />
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '8px 0'
                  }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                      <span className="fontSizeManrope-16" style={{ color: '#555555' }}>
                        Nomor Virtual Account
                      </span>
                      <span className="fontSizeManrope-20-Bold" style={{ color: '#555555' }}>
                        {dataVA?.vaNumber}
                        <Image onClick={() => copyText('Nomor Virtual Account berhasil disalin', dataVA?.vaNumber)} src={icons(iconName.copyNew)} style={{ height:18, width: 18, marginLeft: 6, cursor: 'pointer' }}/>
                      </span>
                    </div>
                
                    <img
                      src={bank?.url_image || icons(iconName.gubuk)}
                      alt="Logo"
                      width="120"
                      height="55"
                      style={{ objectFit: 'contain' }}
                    />
                  </div>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '8px 0'
                  }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                      <span className="fontSizeManrope-16" style={{ color: '#555555' }}>
                        Total Tagihan
                      </span>
                      <span className="fontSizeManrope-20-Bold" style={{ color: '#555555' }}>
                        IDR {Formatter.price(!!dataPayment.totalAmount ? dataPayment.totalAmount : dataPayment.amount)}
                        <Image onClick={() => copyText('Total tagihan berhasil disalin', !!dataPayment.totalAmount ? dataPayment.totalAmount : dataPayment.amount)} src={icons(iconName.copyNew)} style={{ height:18, width: 18, marginLeft: 6, cursor: 'pointer' }}/>
                      </span>
                    </div>
                  </div>
                  <div style={{ border: '1px solid #eee', borderRadius: 8, padding: 16, maxWidth: 500, marginBottom: 10 }}>
                  <div className="fontSize-12-manrope-medium" style={{ marginBottom: 16, textAlign:'center', color: '#696969'}}>Tutorial Transfer</div>
                    <div style={{ display: 'flex', gap: 8, marginBottom: 30 }}>
                      {Object.keys(guide).map((tabName) => (
                        <Button
                          key={tabName}
                          onClick={() => setActiveTab(tabName)}
                          style={{
                            padding: '8px 12px',
                            borderRadius: 8,
                            border: '1px solid #CACACA',
                            backgroundColor: activeTab === tabName ? '#D91818' : '#fff',
                            color: activeTab === tabName ? '#fff' : '#323030',
                            cursor: 'pointer'
                          }}
                          className="fontSize-12-manrope-small"
                        >
                          {tabName}
                        </Button>
                      ))}
                    </div>
                    <div>
                      <ol style={{ paddingLeft: 20, margin: 0 }}>
                      {guide[activeTab]?.map((step, index, arr) => (
                        <li
                          key={index}// eslint-disable-line react/no-array-index-key
                          style={{
                            paddingBottom: 10,
                            marginBottom: 10,
                            borderBottom: index !== arr.length - 1 ? "1px solid #CACACA" : "none",
                            color: '#323030'
                          }}
                          className="fontSize-12-manrope-small"
                        >
                          {step}
                        </li>
                      ))}
                      </ol>
                    </div>
                  </div>
                  </div>

                </div>
              </div>
          )}
          </Col>
          <Col md="6" sm="12" xs="12">
            {/* <div className="alert-info-custom">
              <Image src={icons(iconName.alert)} className="" />
              <div className="color-pink-dark fontSize-20-Regular d-inline">
                {isQris ? 'QRIS ' : 'Virtual Account '} Information will be send to your email :
              </div>
              <div className="fontSize-20-Regular">
                {emailUser}
              </div>
            </div> */}
            <div className="wrapper-detail">
            <div className="detail-full" style={{ paddingBottom:'22px' }}>
                <div className="pt-3 pl-4" style={{ paddingBottom: "20px" }}>
                  <span className="fontSizeManrope-16-Bold" style={{ color: '#555555' }}>Detail Pembayaran</span>
                </div>
                <div className="pl-4 fontSize-12-manrope" style={{ color:'#555555',paddingBottom:'2px' }}>
                  Keperluan transfer
                </div>
                <div className="pl-4 fontSize-12-manrope-small" style={{ color:'#555555', paddingBottom:'10px' }}>
                  {dataPayment?.data.namePayment}
                </div>
                {/* <Row>
                  <Col sm="6" xs="12"> */}
                  <div className="pl-4 fontSize-12-manrope" style={{ color:'#555555', paddingBottom:'2px' }}>
                    Keterangan
                  </div>
                  {/* </Col>
                  <Col sm="6" xs="12"> */}
                  <div className="pl-4 fontSize-12-manrope-small" style={{ color:'#555555' }}>
                    {dataPayment?.data.descPayment}
                  </div>
                  {/* </Col>
                </Row> */}
                <Row style={{ padding: '10px', backgroundColor:'#FFC6C6', width: '90%', maxWidth: '304px', marginLeft: '22px', marginTop: '15px', borderRadius:'8px' }}>
                  <Col sm="6" xs="12">
                    <div className="pl-2 fontSize-12-manrope-small" style={{ color:'#555555', paddingTop:'2px' }}>
                      Tanggal dibuat
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pr-2 fontSize-12-manrope text-right">
                      : {DateTime.format(dateCreate, DateTime.FMT_DATE_YMD)} | {DateTime.format(dateCreate, DateTime.FMT_TIME_HM)}
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pl-2 fontSize-12-manrope-small" style={{ color:'#555555', paddingTop:'2px' }}>
                      Tanggal kedaluarsa
                    </div>
                  </Col>
                  <Col sm="6" xs="12">
                    <div className="pr-2 fontSize-12-manrope text-right">
                      : {DateTime.format(date, DateTime.FMT_DATE_YMD)} | {DateTime.format(date, DateTime.FMT_TIME_HM)}
                    </div>
                  </Col>
                </Row>
            </div>
            </div>
          </Col>
        </Row>
        {/* {selectedBank.bank.urlHelp && (
        <a
          href={selectedBank.bank.urlHelp}
          target="_blank"
          rel="noreferrer"
        >
        <div className="payment-guide">
          <div className="title">
            Payment Guide
          </div>
          <Image src={icons(iconName.arrowRightRed)} className="" />
        </div>
        </a>)} */}
      </div>
    </>
  );
};

export default PaymentRequestPublic;
